export default __webpack_public_path__ + "static/media/WhatsApp.b3871ef8.svg";